/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!**********************************************************!*\
  !*** ./src/assets/js/courses-product-recommendations.js ***!
  \**********************************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

if (!customElements.get('product-recommendations')) {
  var Recommensations = /*#__PURE__*/function (_HTMLElement) {
    _inherits(Recommensations, _HTMLElement);

    var _super = _createSuper(Recommensations);

    function Recommensations() {
      _classCallCheck(this, Recommensations);

      return _super.call(this);
    }

    _createClass(Recommensations, [{
      key: "insertGridProducts",
      value: function insertGridProducts(container, products) {
        var _this = this;

        if (products.length) {
          this.querySelector('.frequently-row-d').innerHTML = container.querySelector(".shopify-section").innerHTML;
          this.querySelectorAll('.courses-product-recommendations__cta-button').forEach(function (button) {
            if (_this.dataset.buttonText != '' && button.getAttribute('data-is-donation') === 'false') {
              button.innerHTML = _this.dataset.buttonText;
            }

            if (_this.dataset.enableRedirect == 'false') {
              if (button.dataset.productUrl != '' && button.dataset.productUrl != undefined) {
                button.href = button.dataset.productUrl;
              }
            }
          });
          this.classList.remove('hidden');
        }
      }
    }, {
      key: "insertSliderProducts",
      value: function insertSliderProducts(container, products) {
        var _this2 = this;

        if (products.length) {
          this.querySelector('.product-recommendations__swiper .swiper-wrapper').innerHTML = container.querySelector(".shopify-section").innerHTML;
          this.querySelectorAll('.frequently-col').forEach(function (slide) {
            return slide.classList.add('swiper-slide');
          });
          this.querySelectorAll('.courses-product-recommendations__cta-button').forEach(function (button) {
            if (_this2.dataset.buttonText != '' && button.getAttribute('data-is-donation') === 'false') {
              button.innerHTML = _this2.dataset.buttonText;
            }

            if (_this2.dataset.enableRedirect == 'false') {
              if (button.dataset.productUrl != '' && button.dataset.productUrl != undefined) {
                button.href = button.dataset.productUrl;
              }
            }
          });
          this.classList.remove('hidden');
        }
      }
    }, {
      key: "initSection",
      value: function initSection() {
        var _this3 = this;

        var baseUrl = this.dataset.baseUrl;
        var productId = this.dataset.productId;
        var limit = this.dataset.limit;
        var showButton = this.dataset.showButton;
        var customFunctional = this.dataset.customEnabled;
        var requestUrl = "".concat(baseUrl, "?section_id=product-recommendations&product_id=", productId, "&limit=", limit);

        if (customFunctional == "false") {
          if (productId) {
            fetch(requestUrl).then(function (response) {
              return response.text();
            }).then(function (data) {
              var container = document.createElement("div");
              container.innerHTML = data;
              var products = container.querySelectorAll(".shopify-section .product-recommendations-item");

              _this3.insertGridProducts(container, products);

              _this3.insertSliderProducts(container, products);

              if (showButton == 'false') {
                if (_this3.querySelectorAll(".courses-product-recommendations__cta-button").length) {
                  _this3.querySelectorAll(".courses-product-recommendations__cta-button").forEach(function (button) {
                    return button.style.display = "none";
                  });
                }
              }
            })["catch"]();
          }
        }
      }
    }, {
      key: "initSlider",
      value: function initSlider() {
        if (this.activeSlider) {
          this.activeSlider.destroy();
        }

        var slider = this.querySelector('.product-recommendations__swiper');
        var pagination = slider.querySelector('.swiper-pagination');
        var sliderOptions = JSON.parse(slider.getAttribute('data-swiper-settings'));

        var options = _objectSpread({
          slidesPerView: 1.163,
          spaceBetween: 16,
          loop: false,
          centeredSlides: false,
          pagination: {
            el: pagination,
            type: 'bullets',
            clickable: true
          }
        }, sliderOptions);

        this.activeSlider = new Swiper(slider, options);
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this4 = this;

        document.addEventListener("DOMContentLoaded", function () {
          _this4.initSection();

          if (window.innerWidth < 1024) {
            _this4.initSlider();
          }
        });
      }
    }]);

    return Recommensations;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

  customElements.define('product-recommendations', Recommensations);
}
/******/ })()
;